import { Directive, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, Subject, debounceTime, takeUntil } from 'rxjs';

import { REQUEST } from 'ish-core/models/express-tokens/express.tokens';
import { selectCleanUrl } from 'ish-core/store/core/router';
import { InjectSingle } from 'ish-core/utils/injection';

import { dotCmsBlogSlugRegex } from '../configurations/dot-cms-regex';
import { DotCmsPageContextFacade } from '../facades/dot-cms-page-context.facade';
import { DotCmsFacade } from '../facades/dot-cms.facade';
import { generateDotCmsRouterURI } from '../utils/dot-cms-utils';

@Directive({
  selector: '[dotCmsPageContext]',
  providers: [{ provide: DotCmsPageContextFacade }],
  exportAs: 'dotCmsPageContext',
  standalone: false,
})
export class DotCmsPageContextDirective implements OnInit, OnDestroy {
  protected pageURI$ = new BehaviorSubject<string>(undefined);
  private destroy$ = new Subject<void>();

  constructor(
    private context: DotCmsPageContextFacade,
    // private activatedRoute: ActivatedRoute,
    private dotCmsFacade: DotCmsFacade,
    private store: Store,
    @Optional() @Inject(REQUEST) private request: InjectSingle<typeof REQUEST>
  ) {}

  ngOnInit(): void {
    // this.activatedRoute.url.pipe(takeUntil(this.destroy$)).subscribe(url => {
    //   this.setDotCmsLanguagePreference();
    //   const navigateByUrl = `/${url.join('/')}`;
    //   this.context.set('pageURI', () => generateDotCmsRouterURI(navigateByUrl));
    //   this.context.set('depth', () => (dotCmsBlogSlugRegex.test(navigateByUrl) ? 3 : 2));
    // });
    this.store.pipe(select(selectCleanUrl), debounceTime(10), takeUntil(this.destroy$)).subscribe(url => {
      this.setDotCmsLanguagePreference();
      this.context.set('pageURI', () => generateDotCmsRouterURI(url));
      this.context.set('depth', () => (dotCmsBlogSlugRegex.test(url) ? 3 : 2));
    });
  }

  private setDotCmsLanguagePreference() {
    if (SSR && this.request?.query?.language_id) {
      const language: string = this.request.query.language_id as string;
      this.dotCmsFacade.setDotCmsPreferredLanguage(+language);
    }
  }
  // private setDotCmsPersonaPreference() {
  //   if (SSR && this.request?.query['com.dotmarketing.persona.id']) {
  //     const persona: string = this.request?.query['com.dotmarketing.persona.id'] as string;
  //     this.dotCmsFacade.setPersona(persona);
  //   }
  // }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
